module.exports = __webpack_public_path__ + "static/media/arrow_drop_down.28d54e81.svg";